<template>
    <div>
        <rkm-form-checkbox-group v-model="model.cidadao.fatoresRisco">
            <rkm-row>
                <rkm-col
                    v-for="fatorRisco in fatoresRisco"
                    v-bind:key="fatorRisco.id"
                    cols="6"
                >
                    <rkm-form-checkbox
                        :value="fatorRisco.id"
                        inline
                    >
                        {{ fatorRisco.nome }}
                    </rkm-form-checkbox>
                </rkm-col>
            </rkm-row>
        </rkm-form-checkbox-group>

        <rkm-row v-if="model.cidadao.fatoresRisco.includes(enums.fatorRisco.OUTRO)">
            <rkm-col>
                <rkm-form-input
                    v-model="model.cidadao.fatorRiscoOutro"
                    :validations="validations.outro"
                    label="Outro fator de risco"
                    uppercase
                />
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
import fatorRisco from '@/enums/cadastro/cidadao/fatorRisco'
import sexo from '@/enums/cadastro/cidadao/sexo'
import deficiencia from '@/enums/cadastro/cidadao/deficienciaBase'

export default {
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    },
    data: () => ({
        enums: {
            fatorRisco,
            sexo,
            deficiencia,
        },
    }),
    computed: {
        validations() {

            return {
                outro: {
                    required: (value) => {

                        const selecionouOutro = this.model.cidadao.fatoresRisco.includes(this.enums.fatorRisco.OUTRO)
                        return !selecionouOutro || (value && value.trim().length > 0)
                    },
                    max: 5000 }
            }
        },
        fatoresRisco(){

            if((this.model.cidadao.sexoId == this.enums.sexo.FEMININO
                && this.model.cidadao.idade >= 9 && this.model.cidadao.idade <= 60) || this.model.cidadao.exibirFatorRiscoGestante){
                    return this.form.fatoresRiscoGestante
            }

            return this.form.fatoresRisco
        }
    },
    watch: {
        'model.cidadao.fatoresRisco': function (newValue, oldValue) {

            if (!newValue.includes(this.enums.fatorRisco.OUTRO)) {

                this.model.cidadao.fatorRiscoOutro = ''
            }

            const deficienciasHasTea = this.model.deficiencias.find(item => item == this.enums.deficiencia.TEA) ? true : false
            const newHasTea = newValue.find(item => item == this.enums.fatorRisco.TEA) ? true : false
            const oldHasTea = oldValue.find(item => item == this.enums.fatorRisco.TEA) ? true : false

            if (deficienciasHasTea && !newHasTea && oldHasTea) {

                const fn = async () => {
                    this.model.cidadao.fatoresRisco.push(this.enums.fatorRisco.TEA)
                }

                const ok = async () => {

                    const index = this.model.deficiencias.indexOf(this.enums.deficiencia.TEA)

                    if (index !== -1) {
                        this.model.deficiencias.splice(index, 1)
                    }
                }

                this.showConfirmation(
                    'O Transtorno do Espectro Autista será removido das deficiências do paciente. Deseja continuar?',
                    ok,
                    fn,
                )
            }

            if (!deficienciasHasTea && newHasTea && !oldHasTea) {

                const ok = async () => this.model.deficiencias.push(this.enums.deficiencia.TEA)

                const fn = async () => {

                    const index = this.model.cidadao.fatoresRisco.indexOf(this.enums.fatorRisco.TEA)

                    if (index !== -1) {
                        this.model.cidadao.fatoresRisco.splice(index, 1)
                    }
                }

                this.showConfirmation(
                    'O Transtorno do Espectro Autista será adicionado nos fatores de risco do paciente. Deseja continuar?',
                    ok,
                    fn,
                )
            }
        }
    }
}
</script>